<div class="grid">
    <table class="table table-sticky tight">
        <thead>
            <tr>
                <ng-container *ngFor="let n of columns; let i = index">
                    <th [class.sticky]="n.sticky && (i == 0 || i == columns.length - 1)"
                        [class.check-cell]="i == 0"
                        [class.sorts]="n.sort"
                        [title]="n.title ? (n.title | translate) : ''"
                        (click)="sort(n)">
                        <div *ngIf="i == 0; else standardTh" class="no-ripple">
                            <mat-checkbox (change)="selectRows($event)" value="true" [checked]="allRowsSelected()"
                                          (click)="$event.stopPropagation()" *ngIf="i == 0"></mat-checkbox>
                            <span>
                                {{n.title ? (n.title | translate) : ''}}
                                <span *ngIf="n.isSorted" class="sorted-{{n.isSorted}}"></span>
                            </span>
                        </div>
                        <ng-template #standardTh>
                            {{n.title ? (n.title | translate) : ''}}
                            <span *ngIf="n.isSorted" class="sorted-{{n.isSorted}}"></span>
                        </ng-template>
                    </th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let n of rows">
                <td>
                    <div class="app-number-cell check-cell">
                        <mat-checkbox (change)="selectRow(n)" [checked]="rowSelected(n)" [disabled]="!n.isCheckable"></mat-checkbox>
                    </div>
                </td>
                <td>{{n.examCode}}</td>
                <td>
                    <a [routerLink]="['/programs', n.programId, 'interviews', n.examId] | localize">
                        {{n.programTitle}}
                    </a>
                </td>
                <td>{{n.notStarted ?? ''}}</td>
                <td>{{n.unfinished ?? ''}}</td>
                <td>{{n.finished ?? ''}}</td>
                <td>{{n.total ?? ''}}</td>
            </tr>
        </tbody>
    </table>
</div>

<div class="table-total">
    <strong>{{rows.length || 0}}</strong> {{'gridTotal' | translate}}
</div>

<div class="cols-wrapper">
    <div class="cols">
        <div class="col-6" *ngIf="rows.length">
            <form #publishForm="ngForm" class="block form-inline">
                <header class="block-header">
                    <h3 [translate]="'admissionInterviews_publish'"></h3>
                </header>

                <div class="block-body">
                    <mat-form-field [style.width.rem]=18>
                        <mat-select [placeholder]="'admissionInterviews_lblPublishTarget' | translate" required name="PublishTarget" [(value)]="publishTarget">
                            <mat-option *ngFor="let t of targetRowTypes" [value]="t">
                                {{'admissionInterviews_targetRows_' + t | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <button type="button" class="btn-inline" mat-raised-button color="primary" (click)="publish()"
                            [disabled]="!(publishTarget && (publishTarget=='All' || (selectedRows && selectedRows.length)))">
                        {{'admissionInterviews_btnPublish' | translate}}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
